import "@css/main.scss";
import "@js/bootstrap";

import {Header} from "@js/components/Header";
import {Slider} from "@js/components/Slider";
import {Scroll} from "@js/animations/Scroll";
import Line from "@js/animations/Line";
import {Accordeons} from "@js/components/Accordeons";
import {Pricing} from "@js/components/Pricing";
import FloatingImages from "./animations/FloatingImages";
import ParallaxImage from "./animations/ParallaxImage";
import AppearAnimation from "./animations/AppearAnimation";

window.onload = () => {

  const lenis = new Scroll();
  new Header(lenis);
  new Slider();
  new Accordeons();
  new Pricing();
  new FloatingImages();
  new ParallaxImage();
  new Line();
  new AppearAnimation();
};
